<template>
  <v-container fluid class="my-v-container">
    <v-app-bar app elevation="0" color="var(--bg-color)">
      <sea-plus-nav-icon></sea-plus-nav-icon>
      <v-spacer></v-spacer>
      <accumulate-nav-button></accumulate-nav-button>
    </v-app-bar>
    <v-card width="600" class="my-v-card">
      <v-card-title>プランを選択</v-card-title>
      <v-card-subtitle>プランを選択してください。</v-card-subtitle>
      <v-card-text>
        <v-row>
          <v-col>
            <v-select :items="plans" placeholder="プランを選択してください" v-model="plan" outlined hide-details>
            </v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <ul>
              <li v-for="(item, index) in planDescArr" :key="index">
                {{ item }}
              </li>
            </ul>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-footer fixed color="var(--bg-color)">
      <v-card-text>
        <v-row dense v-if="plan != Plan.ONE_TIME_PURCHASE">
          <v-col class="subtotal-label"> クーポンコード </v-col>
          <v-col class="subtotal-value">
            <span v-if="couponCode">
              {{ couponCode }}
              <v-btn class="skip-my-style" icon @click="clearCouponCode">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </span>
            <v-btn v-else class="skip-my-style" small @click="enterCouponCode">クーポンを入力する</v-btn>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col class="subtotal-label"> 小計 </v-col>
          <v-col class="subtotal-value" v-if="isLoadingCouponCode">
            <v-progress-circular class="mr-5" indeterminate color="primary" :width="2" :size="20" />
          </v-col>
          <v-col class="subtotal-value" v-else>
            {{ subtotal }}
          </v-col>
        </v-row>
        <v-row dense>
          <v-col>
            <v-btn color="primary" :disabled="isProcessing || !plan" @click="next">
              <v-progress-circular
                v-if="isProcessing"
                indeterminate
                color="primary"
                :width="2"
                :size="20"
              ></v-progress-circular>
              {{ isProcessing ? null : '続行する' }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-footer>
  </v-container>
</template>

<style scoped>
.subtotal-label {
  margin-bottom: 6px;
  font-weight: bold;
  font-size: 1.2em;
}
.subtotal-value {
  margin-bottom: 6px;
  font-weight: bold;
  font-size: 1.2em;
  text-align: right;
}
</style>

<script>
import { createNamespacedHelpers } from 'vuex'
import SeaPlusNavIcon from '@/components/SeaPlusNavIcon.vue'
import { Plan } from '@shared/collections/user.collection'
import AccumulateNavButton from '@/components/buttons/AccumulateNavButton.vue'
import { firebaseAuth } from '@/services/firebase'
import { getCoupon } from '@/services/functions'
import { formatMoney } from '@/helpers/number'

const userStore = createNamespacedHelpers('user')

export const STORAGE_KEY_COUPON_CODE = '__coupon_code__'

export default {
  components: {
    SeaPlusNavIcon,
    AccumulateNavButton
  },
  data: () => ({
    Plan,
    plan: null,
    plans: Plan.all().map((plan) => ({
      text: Plan.getName(plan),
      desc: Plan.getDesc(plan).replaceAll('\n', '<br/>'),
      value: plan
    })),
    couponCode: null,
    coupon: null,
    isLoadingCouponCode: false,
    isProcessing: false
  }),
  computed: {
    ...userStore.mapState(['userId', 'user']),
    planDescArr() {
      return this.plan ? Plan.getDesc(this.plan).split('\n') : []
    },
    subtotal() {
      let tempSubtotal = this.plan ? Plan.getSubtotal(this.plan) : 0
      if (this.coupon && this.plan !== Plan.ONE_TIME_PURCHASE) {
        if (this.coupon.percent_off) {
          tempSubtotal = tempSubtotal * (1 - this.coupon.percent_off / 100)
        } else if (this.coupon.amount_off) {
          tempSubtotal -= this.coupon.amount_off
        }
      }
      return formatMoney(tempSubtotal, '円')
    }
  },
  watch: {
    async couponCode() {
      if (this.couponCode) {
        this.isLoadingCouponCode = true
        const { data } = await getCoupon({ couponCode: this.couponCode })
        this.coupon = data.coupon
        this.isLoadingCouponCode = false
        console.log({ coupon: this.coupon })
        if (!data.coupon) {
          alert('クーポンコードが正しくありません。')
          this.clearCouponCode()
        }
      } else {
        this.coupon = null
        localStorage.removeItem(STORAGE_KEY_COUPON_CODE)
      }
    }
  },
  async mounted() {
    this.plan = this.$route.query.plan || Plan.getDefaultPlan()
    this.couponCode = this.$route.query.couponCode || localStorage.getItem(STORAGE_KEY_COUPON_CODE)
    if (this.$route.query.couponCode) {
      localStorage.setItem(STORAGE_KEY_COUPON_CODE, this.couponCode)
    }
  },
  methods: {
    next() {
      if (this.plan) {
        if (firebaseAuth.currentUser) {
          this.$router.push(`/select-payment-method?plan=${this.plan}`)
        } else {
          this.$router.push(`/sign-up?plan=${this.plan}`)
        }
      }
    },
    enterCouponCode() {
      const newCouponCode = prompt('クーポンコードをご入力してください')
      this.couponCode = newCouponCode
      if (this.couponCode) {
        localStorage.setItem(STORAGE_KEY_COUPON_CODE, this.couponCode)
      }
    },
    clearCouponCode() {
      this.couponCode = null
      this.coupon = null
      localStorage.removeItem(STORAGE_KEY_COUPON_CODE)
    }
  }
}
</script>
